import { PAYMENT_REQUEST } from "../types/PaymentCard";

export const paymentAction = (data,token) => ({
    type: PAYMENT_REQUEST,
    payload: {data,token},
  });
  
  